import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class EmploymentTerminationReasonsService {
   async getEmploymentTerminationReasons() {
      return await http.get(`/employment-termination-reasons`, cacheFirstConfig).then((response) => response.data);
   }
}
